<template>
  <div class="workPlan classsicCase A4Container flexCloumnSingleCenter pageBreak_no">
    <div class="title flexCenter">实习管理典型案例</div>
    <!-- <div class="form textIndent2" v-html="dataInfo.case_content"> -->
    <!-- {{ dataInfo.case_content || '-' }} -->
    <!-- <div class="posDate">{{ dataInfo.report_time ||'' }}</div>
  </div>
  -->
    <div class="form">
      <!-- <div class="textIndent2" v-html="info.sxjh ? info.sxjh.plan_desc : '-'"></div> -->

      <div class="content" style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
        <div id="divCntnrA_classsicCase" style="width:100%;height: 100%;overflow: hidden;
        display: flex;flex-direction: column;justify-content: flex-start;align-items: anchor-center;">
          <div id="resizeDivA_classsicCase" class="scaleDiv_classsicCase"
            v-html="dataInfo.case_content ? dataInfo.case_content : '-'"></div>
        </div>
      </div>


      <div class="posDate">{{ dataInfo.report_time || '' }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cover',
  props: {
    dataInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    let _this = this
    setTimeout(function () {
      _this.$nextTick(() => {
        console.log(36, _this.dataInfo)
        _this.resizeA().then(_ => {
          _this.rescaleA()
        })
      })
    }, 500)
  },
  methods: {
    stripscript(s) {
      var pattern = new RegExp('\n')
      var rs = ''
      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '')
      }
      return rs
    },
    resizeA() {
      return new Promise((resolve, reject) => {
        let id1 = 'divCntnrA_classsicCase'
        let id2 = 'resizeDivA_classsicCase'

        let divHeight = document.getElementById(id1).offsetHeight
        let textHeight = document.getElementById(id2).offsetHeight
        // console.log('a', divHeight, textHeight)
        let i = 1
        while (textHeight > divHeight && i < 7) {
          let pTag = document.getElementById(id2).querySelectorAll('p');
          let olTag = document.getElementById(id2).querySelectorAll('ol');
          let spanTag = document.getElementById(id2).querySelectorAll('span');
          let pLen = pTag.length
          let olLen = olTag.length
          let spanLen = spanTag.length
          // console.log(7575, pLen, olLen)
          if (pTag) {
            for (let tidx = 0; tidx < pLen; tidx++) {
              pTag[tidx].style.margin = '0px';
              pTag[tidx].style.fontSize = `${18 - i}px`;
              // console.log("🌰", tidx);
            }
          }
          if (olTag) {
            for (let olidx = 0; olidx < olLen; olidx++) {
              olTag[olidx].style.margin = '0px';
              olTag[olidx].style.fontSize = `${18 - i}px`;
              // console.log("🍑", olidx);
            }
          }
          if (spanTag) {
            for (let spanidx = 0; spanidx < spanLen; spanidx++) {
              spanTag[spanidx].style.margin = '0px';
              spanTag[spanidx].style.fontSize = `${18 - i}px`;
              // console.log("🍑", spanidx);
            }
          }
          document.getElementById(id2).style.fontSize = `${18 - i}px`
          textHeight = document.getElementById(id2).offsetHeight
          i++

        }
        resolve()
      })
    },
    rescaleA() {
      return new Promise((resolve, reject) => {
        let id1 = 'divCntnrA_classsicCase'
        let id2 = 'resizeDivA_classsicCase'

        let divHeight = document.getElementById(id1).offsetHeight
        let textHeight = document.getElementById(id2).offsetHeight
        // console.log('a', divHeight, textHeight)
        let i = 1
      
        while (textHeight > divHeight && i < 4) {
          // document.getElementById(id2).style.transform = `scale(1,${1 - i * 0.1})`
          document.getElementsByClassName('scaleDiv')[0].style.transform = `scale(1, ${1 - i * 0.1})`

          // console.log(11111, document.getElementById(id2).style.transform = 'scale(1, 0.5)')
          // console.log(3333, document.getElementsByClassName('scaleDiv_classsicCase')[0].style.transform = `scale(1, ${1 - i * 0.1})`)
          textHeight = document.getElementById(id2).offsetHeight * (1 - i * 0.1)
          console.log(textHeight, divHeight, i, 1 - i * 0.1)

          i++
          console.log(i)

        }
        resolve()
      })
    },
  }
}
</script>
<style lang="less" type="text/less">
.classsicCase {
  p {
    margin: 0;
  }
}
</style>